import React from "react";

export default function QEssay() {
    
    return (<div></div>);
}
